export default __webpack_public_path__ + "static/media/add-dao-icon.3143ddc1.png";